import Vue from 'vue'

const UNAUTHORIZED_EVENT = 'onUnauthorized'
const LOGOUT_EVENT = 'onLogout'
const LOGIN_EVENT = 'onLogin'
const TOUR_START_EVENT = 'onTourStart'
const TOUR_END_EVENT = 'onTourEnd'
const BALANCE_CHANGED_EVENT = 'onBalanceChanged'

export const EventBus = new Vue({
  methods: {
    /**
    * Emits the global unauthorized event
    * Register an event handler to the onUnauthorizedEvent to subscribe to it
    */
    emitUnauthorizedEvent (event = {}) {
      this.$emit(UNAUTHORIZED_EVENT, event)
    },

    onUnauthorizedEvent (handler) {
      this.$on(UNAUTHORIZED_EVENT, handler)
    },

    unsubscribeAllUnauthorizedEvent () {
      this.$off(UNAUTHORIZED_EVENT)
    },

    /**
    * Emits the global logout event
    * Register an event handler to the onLogoutEvent to subscribe to it
    */
    emitLogoutEvent () {
      this.$emit(LOGOUT_EVENT, {})
    },

    onLogoutEvent (handler) {
      this.$on(LOGOUT_EVENT, handler)
    },

    unsubscribeAllLogoutEvent () {
      this.$off(LOGOUT_EVENT)
    },

    /**
    * Emits the global login event
    * Register an event handler to the onLogoutEvent to subscribe to it
    */
    emitLoginEvent () {
      this.$emit(LOGIN_EVENT, {})
    },

    onLoginEvent (handler) {
      this.$on(LOGIN_EVENT, handler)
    },

    unsubscribeAllLoginEvent () {
      this.$off(LOGIN_EVENT)
    },

    /**
    * Emits the global tour started event
    * Register an event handler to the onTourStartEvent to subscribe to it
    */
    emitTourStartEvent () {
      this.$emit(TOUR_START_EVENT, {})
    },

    onTourStartEvent (handler) {
      this.$on(TOUR_START_EVENT, handler)
    },

    /**
    * Emits the global tour ended event
    * Register an event handler to the onTourEndEvent to subscribe to it
    */
    emitTourEndEvent () {
      this.$emit(TOUR_END_EVENT, {})
    },

    onTourEndEvent (handler) {
      this.$on(TOUR_END_EVENT, handler)
    },

    /**
    * Emits the global balance changed event
    * Trigger this event when user balance changes, a voucher is redeemed etc.
    * Register an event handler to the onBalanceChangedEvent to subscribe to it
    */
    emitBalanceChangedEvent () {
      this.$emit(BALANCE_CHANGED_EVENT, {})
    },

    onBalanceChangedEvent (handler) {
      this.$on(BALANCE_CHANGED_EVENT, handler)
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/eventBus.js